<template>
  <div class="box7">
    <div class="titleBox">
      <div class="subtitle">
        按照老师的指导他们突破瓶颈<br />
        月自然流量佣金2w+，单条广告报价8000+
      </div>
      <img src="../../../assets/coursePage/media/box6/line.png" alt="" />
    </div>
    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide
          v-for="(item, index) in 3"
          :key="index"
          :class="'block' + (index + 1)"
          :style="
            `background-image: url(` +
            require(`../../../assets/coursePage/media/box7/${index + 1}.png`) +
            `)`
          "
        >
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-box7"></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  mounted() {},
  data() {
    return {
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, //false时用户操作后，重新轮播
          reverseDirection: false, //反向轮播
        },

        pagination: {
          el: ".swiper-pagination-box7",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box7 {
  margin-top: 80px;
  .titleBox {
    text-align: center;

    .subtitle {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #826aff;
      line-height: 40px;
      margin-top: 0px;
    }
    img {
      width: 750px;
      height: 20px;
    }
  }
  .subject-content {
    position: relative;
    margin-top: 48px;

    width: 100%;
    box-sizing: border-box;
  }

  .swiper-slide {
    margin-left: 30px;
    width: 690px;
    height: 530px;
    background-size: contain;
    border-radius: 20px;
    overflow: hidden;
  }

  .swiper-pagination-box7 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    margin-top: 32px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: #b7a9ff;
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #b7a9ff;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #775cff;
    border-radius: 3px;
  }
}
</style>
